import { render, staticRenderFns } from "./WeeklyReward.vue?vue&type=template&id=2e45a9d7&lang=pug"
import script from "./WeeklyReward.vue?vue&type=script&lang=js"
export * from "./WeeklyReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports